import React from "react";
import ReactDOM from "react-dom/client";
import posthog from "posthog-js";
import "@/index.css";
import App from "@/App";

// Initialize PostHog for heatmaps and session recordings
if (typeof window !== 'undefined') {
  posthog.init('phc_placeholder_key', {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    // Enable heatmaps
    enable_heatmaps: true,
    // Session recording with privacy settings
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '.sensitive-data',
    },
    // Autocapture for button clicks and form submissions
    autocapture: true,
    // Privacy-first - only track identified users
    persistence: 'localStorage',
    // Respect Do Not Track
    respect_dnt: true,
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
